import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isSameMonth } from 'date-fns/isSameMonth';
import { parse } from 'date-fns/parse';
import { setDate } from 'date-fns/setDate';

import Table from './Table';
import { defaultProps, getMonthView } from '../utils';
import { requiresParsing } from '../utils/parse';

class View extends React.Component {
  static propTypes = {
    activeDate: PropTypes.instanceOf(Date),
    value: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    hoverValue: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
    onSelect: PropTypes.func,
    onMouseMove: PropTypes.func,
    disabledDate: PropTypes.func,
    isoWeek: PropTypes.bool,
    className: PropTypes.string,
    classPrefix: PropTypes.string,
  };

  static defaultProps = {
    activeDate: new Date(),
  };

  inSameThisMonthDate = (date) => {
    const parsedDate = requiresParsing(this.props.activeDate)
      ? parse(this.props.activeDate, 'yyyy-MM-dd', new Date())
      : this.props.activeDate;
    const thisMonthDate = setDate(parsedDate, 1);
    return isSameMonth(date, thisMonthDate);
  };

  render() {
    const {
      activeDate,
      value,
      hoverValue,
      onSelect,
      onMouseMove,
      disabledDate,
      className,
      isoWeek,
      classPrefix,
      showWeekNumbers,
      todayDate, //for showing today date in business timeZone if it differs from local timeZone
      ...rest
    } = this.props;

    const activeDateAsDate = requiresParsing(activeDate)
      ? parse(activeDate, 'yyyy-MM-dd', new Date())
      : activeDate;

    const thisMonthDate = setDate(activeDateAsDate, 1);
    const classes = classNames(classPrefix, className);

    return (
      <div {...rest} className={classes}>
        <Table
          rows={getMonthView(thisMonthDate, isoWeek)}
          isoWeek={isoWeek}
          selected={value}
          onSelect={onSelect}
          onMouseMove={onMouseMove}
          inSameMonth={this.inSameThisMonthDate}
          disabledDate={disabledDate}
          hoverValue={hoverValue}
          showWeekNumbers={showWeekNumbers}
          todayDate={todayDate}
        />
      </div>
    );
  }
}

const enhance = defaultProps({
  classPrefix: 'calendar-view',
});

export default enhance(View);
